module.exports = __webpack_public_path__ + "static/media/insta02.c0275e55.jpg";